import React, { useEffect, useMemo } from 'react'
import { Alert } from '@patternfly/react-core'
import { hasAllRequired } from '../helpers/labels'

export function LabelsValidator(props: {
  finalServiceDeps: any[]
  storedLabelsInfo: Record<string, { requiredLabels: Record<string, boolean>, found: {name:string; value:string}[] }>
  labelsByApp: Record<string, { found: { name: string; value: string }[]; domainValue: string | null }>
  onMissingLabelsChange?: (hasMissing: boolean) => void
}) {
  const { finalServiceDeps, storedLabelsInfo, labelsByApp, onMissingLabelsChange } = props

  const unlabeledForSelection = useMemo(
    () => finalServiceDeps
      .filter(d => !hasAllRequired(d.name, storedLabelsInfo, labelsByApp))
      .map(d => d.name),
    [finalServiceDeps, storedLabelsInfo, labelsByApp]
  )

  const hasMissing = unlabeledForSelection.length > 0

  useEffect(() => {
    if (onMissingLabelsChange) onMissingLabelsChange(hasMissing)
  }, [hasMissing, onMissingLabelsChange])

  if (!hasMissing) return null

  return (
    <div>
      <Alert
        variant="danger"
        isInline
        title="Some services are missing required labels"
        style={{ marginBottom: '1rem' }}
      >
        Apps missing required labels: {unlabeledForSelection.join(', ')}.{" "}
        Deployment is blocked until all required labels are added.{" "}
        <a
          href="https://teladochealth.atlassian.net/wiki/spaces/DEVOPS/pages/312541206/How+to+label+your+workflows+in+your+service"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here for more info on How to add labels
        </a>
      </Alert>
    </div>
  )
}


